'use client';

import React, { useState, useEffect } from 'react';



interface Certification {
  id: number;
  name: string;
  authority: string;
  year: string;
  icon: string;
  image: string;
  alt: string;
}

const certifications: Certification[] = [
{
  id: 1,
  name: 'EU-GMP Certified',
  authority: 'European Medicines Agency',
  year: '2018',
  icon: 'ShieldCheckIcon',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1794d49db-1764666848579.png",
  alt: 'European Union flag with pharmaceutical certification documents and official stamps on desk'
},
{
  id: 2,
  name: 'WHO-GMP Approved',
  authority: 'World Health Organization',
  year: '2016',
  icon: 'GlobeAltIcon',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d82fd8d1-1766416778594.png",
  alt: 'World Health Organization logo displayed on computer screen with pharmaceutical compliance documents'
},
{
  id: 3,
  name: 'ANVISA Registered',
  authority: 'Brazilian Health Authority',
  year: '2020',
  icon: 'DocumentCheckIcon',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_11f4f09a5-1767395395165.png",
  alt: 'Brazilian regulatory authority certification documents with official seals and approval stamps'
},
{
  id: 4,
  name: 'ISO 9001:2015',
  authority: 'International Standards',
  year: '2019',
  icon: 'CheckBadgeIcon',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_15acd7e81-1764666198770.png",
  alt: 'ISO quality management certification certificate with gold seal and international standards documentation'
}];


export default function TrustSignals() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % certifications.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return;




































































































































}